import { Image } from 'app/src/shared/components'
import discountImage from 'app/static/images/discountImage.svg'
import { Card } from 'primereact/card'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function DiscountSection(): ReactElement {
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.Discount' })

  return (
    <div>
      <div className='titleCenter'>
        <h3>{t('Title')}</h3>
      </div>
      <div>
        <Card>
          <div className='grid grid-rows-2 gap-4 md:grid-cols-12 md:grid-rows-1'>
            <div className='p-4 text-center md:col-span-2'>
              <Image alt='Immagine sezione sconti' src={discountImage} />
            </div>
            <div className='flex items-center justify-center p-4 md:col-span-10'>
              <p className='m-0'>{t('Text')}</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
